export const SET_CUSTOMERS_LOADED = 'SET_CUSTOMERS_LOADED';
export const SET_APPOINTMENTS_LOADED = 'SET_APPOINTMENTS_LOADED';
export const SET_REPORT_APPOINTMENTS_LOADED = 'SET_REPORT_APPOINTMENTS_LOADED';
export const LOADING_STARTED = 'LOADING_STARTED';
export const CONFIRMATION_REQUIRED_STATUS = 406;

export const PUBNUB_CHANGED = 'PUBNUB_CHANGED';
export const PUBNUB_HANDLED = 'PUBNUB_HANDLED';

export const DAYS_OF_WEEK_OPTIONS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 7, label: 'Sunday' },
];

export const TIME_TRACKING_ROLES = {
  'service provider': { label: 'Service provider', field: 'serviceProvider' },
  'split sales': { label: 'Split sales', field: 'splitSales' },
  manager: { label: 'Manager', field: 'manager' },
  GM: { label: 'GM', field: 'gm' },
  receptionist: { label: 'Receptionist', field: 'receptionist' },
  meeting: { label: 'Meeting', field: 'meeting' },
  admin: { label: 'Admin', field: 'admin' },
};

export const DEFAULT_TRACKING_ROLE = Object.keys(TIME_TRACKING_ROLES)[0];

export const getDefaultTrackingRole = (allowedRoles) => {
  const isGlobalDefaultAllowed = allowedRoles.some((role) => role === DEFAULT_TRACKING_ROLE);
  return isGlobalDefaultAllowed ? DEFAULT_TRACKING_ROLE : allowedRoles[0];
};
